import {
  DeleteOutlined,
  InfoCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import ActivityLog from '@components/activityLog/ActivityLog'
import Page from '@components/Page/Page'
import { useAppSelector } from '@store/hooks'
import { selectSelectedVenue } from '@store/VenueReducer'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Alert, Button, Card, Col, Descriptions, Flex, Typography } from 'antd'
import dayjs from 'dayjs'

const { Text, Title } = Typography

const SettingsTab = () => {
  const venue = useAppSelector(selectSelectedVenue())

  if (!venue) {
    return <></>
  }

  return (
    <Page noWrapWithCol rowGutter={[32, 32]}>
      <Col span={10}>
        <Flex vertical gap={32}>
          <Flex vertical gap={8}>
            <Title level={5} className="m-0">
              <InfoCircleOutlined /> Venue information
            </Title>
            <Card styles={{ body: { padding: 20 } }}>
              <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Creator">
                  {venue.creatorName || '--'}
                </Descriptions.Item>
                <Descriptions.Item label="Creation date">
                  {dayjs(venue.createdAt).format('YYYY-MM-DD HH:mm')}
                </Descriptions.Item>
                <Descriptions.Item label="Internal ID">
                  <Text copyable>{venue.id}</Text>
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Flex>
          <Flex vertical gap={8}>
            <Title level={5} className="m-0">
              <WarningOutlined /> Danger zone
            </Title>
            <Alert
              description={
                <Text>
                  <Text type="danger">
                    Deleting the venue will also delete all associated
                    resources, menus, gallery, connectors...<br></br>This action
                    is immediate and cannot be undone.
                  </Text>
                </Text>
              }
              action={
                <SBRM.Actions
                  entity={Entity.venue}
                  entityId={venue.id}
                  actions={[SBRMAction.Delete]}
                  trigger={
                    <Button danger>
                      <DeleteOutlined /> Delete
                    </Button>
                  }
                />
              }
              type="error"
            />
          </Flex>
        </Flex>
      </Col>
      <Col span={14}>
        <ActivityLog.Timeline
          entity="venue"
          entityId={venue.id}
          cardProps={{
            style: { maxHeight: 500, overflow: 'scroll', padding: 10 },
          }}
        />
      </Col>
    </Page>
  )
}

export default SettingsTab
